import {Component, OnInit} from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

    topbarTheme: string = 'red';

    menuTheme: string = 'dark';

    layoutMode: string = 'light';

    menuMode: string = 'static';

    inlineMenuPosition: string = 'bottom';

    inputStyle: string = 'filled';

    ripple: boolean = true;

    isRTL: boolean = false;

    constructor(private primengConfig: PrimeNGConfig, private translate: TranslateService) {
        translate.setDefaultLang('pt');
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
    }
}
